export const FORM_SUBMIT_BEGIN='FORM_SUBMIT_BEGIN';
export const FORM_SUBMIT_SUCCESS='FORM_SUBMIT_SUCCESS';
export const FORM_SUBMIT_FAIL='FORM_SUBMIT_FAIL';

export const FETCH_ACTION_BEGIN='FETCH_ACTION_BEGIN';
export const FETCH_ACTION_SUCCESS='FETCH_ACTION_SUCCESS';
export const FETCH_ACTION_FAIL='FETCH_ACTION_FAIL';

export const SUCCESS = 'success';
export const ERROR = 'error';
export const UPDATE_CART = 'UPDATE_CART';
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const MODIFY_CART = 'MODIFY_CART';
export const PRODUCT_URL = 'PRODUCT_URL';
export const CUSTOMER_ALSO_VIEWED = 'CUSTOMER_ALSO_VIEWED';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_STATES = 'GET_STATES';

export const FETCH_SHIPPING_CONTENTS='FETCH_SHIPPING_CONTENTS';
export const WHISHLIST_ACTION_URL='WHISHLIST_ACTION_URL';

export const BILLING_ACTION_BEGIN='BILLING_ACTION_BEGIN';
export const BILLING_ACTION_SUCCESS='BILLING_ACTION_SUCCESS';
export const BILLING_ACTION_FAIL='BILLING_ACTION_FAIL';


export const RESOURCE_BUNDLE_ACTION_BEGIN='RESOURCE_BUNDLE_ACTION_BEGIN';
export const RESOURCE_BUNDLE_ACTION_SUCCESS='RESOURCE_BUNDLE_ACTION_SUCCESS';
export const RESOURCE_BUNDLE_ACTION_FAIL='RESOURCE_BUNDLE_ACTION_FAIL';

export const FOOTER_SUBMIT_BEGIN='FOOTER_SUBMIT_BEGIN';
export const FOOTER_SUBMIT_SUCCESS='FOOTER_SUBMIT_SUCCESS';
export const FOOTER_SUBMIT_FAIL='FOOTER_SUBMIT_FAIL';

export const LOGOUT_ACTION_BEGIN='LOGOUT_ACTION_BEGIN';
export const LOGOUT_ACTION_SUCCESS='LOGOUT_ACTION_SUCCESS';
export const LOGOUT_ACTION_FAIL='LOGOUT_ACTION_FAIL';

export const MENU_ACTION_BEGIN= 'MENU_ACTION_BEGIN';
export const MENU_ACTION_SUCCESS= 'MENU_ACTION_SUCCESS';
export const MENU_ACTION_FAIL= 'MENU_ACTION_FAIL';

export const CHANGE_USERLOGIN_ACTION_BEGIN= 'CHANGE_USERLOGIN_ACTION_BEGIN';
export const CHANGE_USERLOGIN_ACTION_SUCCESS= 'CHANGE_USERLOGIN_ACTION_SUCCESS';
export const CHANGE_USERLOGIN_ACTION_FAIL= 'CHANGE_USERLOGIN_ACTION_FAIL';

export const SKIN_ACTION_BEGIN='SKIN_ACTION_BEGIN';
export const SKIN_ACTION_SUCCESS='SKIN_ACTION_SUCCESS';
export const SKIN_ACTION_FAIL='SKIN_ACTION_FAIL';

export const NEXT_SUBMIT_BEGIN='NEXT_SUBMIT_BEGIN';
export const NEXT_SUBMIT_SUCCESS='NEXT_SUBMIT_SUCCESS';
export const NEXT_SUBMIT_FAIL='NEXT_SUBMIT_FAIL';


export const PAGE_SUBMIT_BEGIN='PAGE_SUBMIT_BEGIN';
export const PAGE_SUBMIT_SUCCESS='PAGE_SUBMIT_SUCCESS';
export const PAGE_SUBMIT_FAIL='PAGE_SUBMIT_FAIL';

export const GET_TEMP_PROPERTIES_BEGIN='GET_TEMP_PROPERTIES_BEGIN';
export const GET_TEMP_PROPERTIES_SUCCESS='GET_TEMP_PROPERTIES_SUCCESS';
export const GET_TEMP_PROPERTIES_FAIL='GET_TEMP_PROPERTIES_FAIL';


export const PAGINATION_ACTION_BEGIN='PAGINATION_ACTION_BEGIN';
export const PAGINATION_ACTION_SUCCESS='PAGINATION_ACTION_SUCCESS';
export const PAGINATION_ACTION_FAIL='PAGINATION_ACTION_FAIL';

export const ROWS_PER_PAGE_OPTION_ACTION_BEGIN='ROWS_PER_PAGE_OPTION_ACTION_BEGIN';
export const ROWS_PER_PAGE_OPTION_ACTION_SUCCESS='ROWS_PER_PAGE_OPTION_ACTION_SUCCESS';
export const ROWS_PER_PAGE_OPTION_ACTION_FAIL='ROWS_PER_PAGE_OPTION_ACTION_FAIL';

export const LOGIN_FORM_SUBMIT_BEGIN= 'LOGIN_FORM_SUBMIT_BEGIN';
export const LOGIN_FORM_SUBMIT_SUCCESS= 'LOGIN_FORM_SUBMIT_SUCCESS';
export const LOGIN_FORM_SUBMIT_FAIL= 'LOGIN_FORM_SUBMIT_FAIL';

export const LOG_OUT_BEGIN= 'LOG_OUT_BEGIN';
export const LOG_OUT_SUCCESS= 'LOG_OUT_SUCCESS';
export const LOG_OUT_FAIL= 'LOG_OUT_FAIL';

export const SOLR_PAGINATION_ACTION_BEGIN='SOLR_PAGINATION_ACTION_BEGIN';
export const SOLR_PAGINATION_ACTION_SUCCESS='SOLR_PAGINATION_ACTION_SUCCESS';
export const SOLR_PAGINATION_ACTION_FAIL='SOLR_PAGINATION_ACTION_FAIL';
export const SOLR_FACET_ACTION_RESET='SOLR_FACET_ACTION_RESET';

export const SOLR_FACET_ACTION_BEGIN='SOLR_FACET_ACTION_BEGIN';
export const SOLR_FACET_ACTION_SUCCESS='SOLR_FACET_ACTION_SUCCESS';
export const SOLR_FACET_ACTION_FAIL='SOLR_FACET_ACTION_FAIL';

export const GET_URL_MAPPINGS_ACTION_BEGIN='GET_URL_MAPPINGS_ACTION_BEGIN';
export const GET_URL_MAPPINGS_ACTION_SUCCESS='GET_URL_MAPPINGS_ACTION_SUCCESS';
export const GET_URL_MAPPINGS_ACTION_FAIL='GET_URL_MAPPINGS_ACTION_FAIL';

export const GET_LOADER_STATUS='GET_LOADER_STATUS';
export const GET_LOGIN_STATUS='GET_LOGIN_STATUS';
export const GET_CART_UPDATED_STATUS='GET_CART_UPDATED_STATUS';

export const GET_PROFILE_DETAILS='GET_PROFILE_DETAILS';

export const UPDATE_ADD_TO_CART='UPDATE_ADD_TO_CART';
export const APPLICATION_JSON="application/json";
export const UPDATE_URL="UPDATE_URL";
export const UPDATE_MESSAGE="UPDATE_MESSAGE";
export const SET_MERGE_VALUE="SET_MERGE_VALUE";
export const SET_COMMERCE_ITEM_VALUE="SET_COMMERCE_ITEM_VALUE";
export const GET_MINI_CART_COUNT_ACTION_BEGIN=' GET_MINI_CART_COUNT_ACTION_BEGIN';
export const GET_MINI_CART_COUNT_ACTION_SUCCESS='GET_MINI_CART_COUNT_ACTION_SUCCESS';
export const GET_MINI_CART_COUNT_ACTION_FAIL='GET_MINI_CART_COUNT_ACTION_FAIL';
export const UPDATE_REGISTER_MESSAGE='UPDATE_REGISTER_MESSAGE';
export const UPDATE_PROFILE_DETAILS='UPDATE_PROFILE_DETAILS';
export const GET_ORGANIZATION_DETAILS='GET_ORGANIZATION_DETAILS';
export const GET_SHOPPING_LIST_DETAILS='GET_SHOPPING_LIST_DETAILS';
export const UPDATE_SHOPPING_LIST_DETAILS='UPDATE_SHOPPING_LIST_DETAILS';
export const SET_CHECKOUT_HEADER_OPTIONS ='SET_CHECKOUT_HEADER_OPTIONS';
export const DEFAULT_IMAGE_60 = "/vaststatic/static-assets/common/resources/images/product-60x60.png";
export const DEFAULT_IMAGE_140 = "/vaststatic/static-assets/common/resources/images/product-140x140.gif";
export const DEFAULT_IMAGE_220 = "/vaststatic/static-assets/common/resources/images/product-220x220.png";
export const DEFAULT_IMAGE_400 = "/vaststatic/static-assets/common/resources/images/product-400x400.gif";
export const DEFAULT_IMAGE_400_OSE = "/vaststatic/static-assets/common/resources/images/no-image.jpg";
export const DEFAULT_IMAGE_140_OSE = "/vaststatic/static-assets/common/resources/images/no-image-small.jpg";
export const ZIP_CODE_API_KEY = "js-SS6GCuyiIHK8JE7mMNcC4NSX2Te7lz69aKHOjggnVMYbcEVwARAWrkeRm0n6DbEt";
export const GET_CART_DETAILS = 'GET_CART_DETAILS';

export const GET_SEARCH_VALUE ='GET_SEARCH_VALUE';
